import { NodoDto } from "@/api";
import NodoCard from "@/components/NodoCard";
import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { TextField } from "@mui/material";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export default function GatewayRipetitoriTable({ nodo }: { nodo: NodoDto }) {
  const { t } = useTranslation();
  const gatewayERipetitori = useMemo(() => {
    return (
      nodo.nodiFigli?.filter(
        (x) => x.tipo === "Gateway" || x.tipo === "Ripetitore"
      ) ?? []
    );
  }, [nodo.nodiFigli]);

  return (
    <Box flex={1}>
      <Box display="flex" flexDirection="column" height="100%" gap={1}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          gap={1}
        >
          <Typography variant="h5" color="text" fontWeight="medium">
            {t("nodoPage.gatewayRipetitori.titolo")}
          </Typography>
        </Box>
      </Box>

      <Box
        mt={2}
        mb={0}
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        gap={2}
      >
        {gatewayERipetitori.map((gatewayORipetitore) => {
          return (
            <NodoCard key={gatewayORipetitore.id} nodo={gatewayORipetitore} />
          );
        })}
      </Box>
    </Box>
  );
}
